import { render } from "./PraxisgruppeAddAccountDialog.vue?vue&type=template&id=c5871ce6&ts=true"
import script from "./PraxisgruppeAddAccountDialog.vue?vue&type=script&lang=ts"
export * from "./PraxisgruppeAddAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__